import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { Separator } from "@babackapp/ui/components/separator";
import useAddWebhook from "@babackapp/private-api-client/client/use-add-webhook";
import { PropsWithChildren, useState } from "react";
import useTranslation from "@babackapp/translations/use-translation";
import WebhookForm from "./webhook-form.tsx";

export default function AddWebhookDialog({ children }: PropsWithChildren) {
  const t = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { data: shop } = useCurrentShopSuspense();

  const { mutate: addWebhook } = useAddWebhook(shop);

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.webhooks.title")}</DialogTitle>
          <DialogDescription>
            {t("settings.integrations.webhooks.subtitle")}
          </DialogDescription>
        </DialogHeader>
        <Separator className="mt-4" />
        <WebhookForm onSubmit={addWebhook} />
      </DialogContent>
    </Dialog>
  );
}
